/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage difference between two numbers`)
};

const es_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferencia porcentual entre dos números`)
};

const de_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozentualer Unterschied zwischen zwei Zahlen`)
};

const nl_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentageverschil tussen twee getallen`)
};

const fr_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Différence en pourcentage entre deux nombres`)
};

const it_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differenza percentuale tra due numeri`)
};

const pt_br2_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferença percentual entre dois números`)
};

const pt_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferença percentual entre dois números`)
};

const ja_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの数値の間のパーセントの差`)
};

const zh_pct_nav_difference_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两个数字之间的百分比差异`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_nav_difference_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_nav_difference_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_nav_difference_desc", locale)
	if (locale === "en") return en_pct_nav_difference_desc(inputs)
	if (locale === "es") return es_pct_nav_difference_desc(inputs)
	if (locale === "de") return de_pct_nav_difference_desc(inputs)
	if (locale === "nl") return nl_pct_nav_difference_desc(inputs)
	if (locale === "fr") return fr_pct_nav_difference_desc(inputs)
	if (locale === "it") return it_pct_nav_difference_desc(inputs)
	if (locale === "pt-BR") return pt_br2_pct_nav_difference_desc(inputs)
	if (locale === "pt") return pt_pct_nav_difference_desc(inputs)
	if (locale === "ja") return ja_pct_nav_difference_desc(inputs)
	return zh_pct_nav_difference_desc(inputs)
};